import React from 'react';
import { Card, Row, Col, Statistic, Spin } from 'antd';
import {
  QuestionCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import type { MiniQuizStatistics } from '@/types';

interface QuizStatisticsProps {
  statistics: MiniQuizStatistics | null;
  loading: boolean;
}

const QuizStatistics: React.FC<QuizStatisticsProps> = ({
  statistics,
  loading,
}) => {
  if (loading) {
    return (
      <Card>
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  if (!statistics) {
    return null;
  }

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title="Total Questions"
            value={statistics.overview.totalQuestions}
            prefix={<QuestionCircleOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title="Active Questions"
            value={statistics.overview.activeQuestions}
            prefix={<CheckCircleOutlined />}
            valueStyle={{ color: '#52c41a' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title="Inactive Questions"
            value={statistics.overview.inactiveQuestions}
            prefix={<CloseCircleOutlined />}
            valueStyle={{ color: '#ff4d4f' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card>
          <Statistic
            title="Active Rate"
            value={
              statistics.overview.totalQuestions > 0
                ? Math.round(
                    (statistics.overview.activeQuestions /
                      statistics.overview.totalQuestions) *
                      100
                  )
                : 0
            }
            suffix="%"
            prefix={<BarChartOutlined />}
            valueStyle={{
              color:
                statistics.overview.totalQuestions > 0 &&
                statistics.overview.activeQuestions /
                  statistics.overview.totalQuestions >=
                  0.7
                  ? '#52c41a'
                  : '#faad14',
            }}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default QuizStatistics;
